import ChatContainer from '@containers/chat/chat2.container';
import CalendarContainer from '@containers/calendar/calendar.container';
import InfoBankContainer from '@containers/childinfo/infobank.container';
import NotesContainer from '@containers/notes/notes.container';
import EconomyContainer from '@containers/economy/economy.container';
import Onboarding from '@containers/onboarding/onboarding.container';
import Settings from '@containers/settings/settings.container';
import KnowledgeContainer from "@containers/knowledge/knowledge.container";
import {SettingsSvg} from '../images/settings';
import {KnowledgeSvg} from '../images/knowledge';
import {CalendarSvg} from '../images/calendar';
// import {CabinetSvg} from '../images/cabinet';
import {WalletSvg} from '../images/wallet';
// import {MessageSvg} from '../images/message';
import {ChildrenSvg} from '../images/children';
import ListIcon from "@material-ui/icons/FormatListBulletedRounded";
import ChatIcon from "@material-ui/icons/ChatOutlined";

import BookLogo from '@images/bookLogo';
import { RouteConfig } from 'react-router-config';
// import { default as MailIcon } from '@material-ui/icons/Mail';
// import MenuBookIcon from '@material-ui/icons/MenuBook';
// import ProIcon from '@material-ui/icons/School';
// import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
// import { default as SettingsIcon } from '@material-ui/icons/Settings';
// import { default as CreditCardIcon } from '@material-ui/icons/CreditCard';
// import { default as EventIcon } from '@material-ui/icons/Event';



export const privatRoutesPathes = {  
  APP: '/app',
  CALENDAR: '/app/calendar',
  MESSAGES: '/app/messages',
  SETTINGS: '/app/settings',
  KNOWLEDGE: '/app/knowledge',
  ONBOARDING: '/app/onboarding',
  SCHEDULES: '/app/schedules',
  INFOBANK: '/app/info',
  NOTES: '/app/notes',
  ECONOMY: '/app/economy',
};

export const privatRoutesNames = {  
  MESSAGES: "messages",
  SCHEDULES: "schedules",
  SETTINGS: "settings",
  KNOWLEDGE: "knowledge",
  ONBOARDING: "onboarding",
  CALENDAR: "calendar",
  INFOBANK: "info",
  ECONOMY: "economy",
  NOTES: "notes",
};

export const publicRoutesPathes = {
  FORGOT_PASSWORD: '/forgot-password'
};

export const privateMainRoutes: RouteConfig[] = [
  {
    component: Onboarding,
    icon: KnowledgeSvg,
    path: privatRoutesPathes.ONBOARDING,
    sidebarName: null, // privatRoutesNames.ONBOARDING, // set sidebar name to null to not show it in sidebar
  },
  {
    component: CalendarContainer,
    icon: CalendarSvg,
    path: privatRoutesPathes.CALENDAR+'/:calendarId/:suggestionId',
    exact: false,
    sidebarName: privatRoutesNames.CALENDAR,
  },
  {
    component: CalendarContainer,
    icon: CalendarSvg,
    path: privatRoutesPathes.CALENDAR,
    sidebarName: null,
  },
  {
    component: InfoBankContainer,
    icon: ChildrenSvg,
    path: privatRoutesPathes.INFOBANK+'/:tab',
    sidebarName: privatRoutesNames.INFOBANK, 
  },
  {
    component: ChatContainer,
    icon: ChatIcon,
    path: `${privatRoutesPathes.MESSAGES}/:chatId`,
    sidebarName: privatRoutesNames.MESSAGES,
  },
  {
    component: NotesContainer,
    icon: ListIcon,
    path: privatRoutesPathes.NOTES+'/:tab',
    sidebarName: privatRoutesNames.NOTES, 
  },
  {
    component: EconomyContainer,
    icon: WalletSvg,
    path: privatRoutesPathes.ECONOMY+'/:transactionId',
    sidebarName: privatRoutesNames.ECONOMY, 
  },
  // {
  //   component: CalendarContainer,
  //   icon: CalendarSvg,
  //   path: privatRoutesPathes.SCHEDULES+'/:scheduleId',
  //   sidebarName: privatRoutesNames.SCHEDULES,
  // },
  // {
  //   component: CalendarManagementContainer,
  //   icon: ScheduleIcon,
  //   path: privatRoutesPathes.CALENDAR,
  //   sidebarName: privatRoutesNames.CALENDAR,
  // },
  {
    component: KnowledgeContainer,
    icon: BookLogo,
    path: privatRoutesPathes.KNOWLEDGE,
    sidebarName: privatRoutesNames.KNOWLEDGE,
  },
  // {
  //   component: UnderConstruction,
  //   icon: CreditCardIcon,
  //   path: privatRoutesPathes.FINANCES,
  //   sidebarName: privatRoutesNames.FINANCES,
  // },
  // {
  //   component: UnderConstruction,
  //   icon: PeopleIcon,
  //   path: privatRoutesPathes.AGREEMENTS,
  //   sidebarName: privatRoutesNames.AGREEMENTS,
  // },
  {
    component: Settings,
    icon: SettingsSvg,
    path: `${privatRoutesPathes.SETTINGS}/:userId`,
    sidebarName: privatRoutesNames.SETTINGS,
  },

  { redirect: true, path: privatRoutesPathes.APP, to: privatRoutesPathes.CALENDAR },
  
];



// WEBPACK FOOTER //
// ./src/router/router.constants.tsx